(function () {
  /* AMAR - il Diwan si apre con la fragranza di provenienza gia' scelta.

     Chi clicca "Cofanetto Scoperta" da una scheda prodotto arriva con
     ?con=<id prodotto>. Qui si cerca la scheda corrispondente nel listino del
     compositore e le si manda un clic: da li' in poi lavora il codice della
     sezione, con la sua animazione di volo e il suo stato. Nessuna logica
     duplicata, e la sezione da 38 KB non e' stata toccata.

     Il parametro viene tolto dall'indirizzo solo dopo aver verificato che la
     fragranza sia davvero entrata nel vassoio: se il listino non e' ancora
     pronto si riprova, invece di perdere l'intenzione di chi e' arrivato.

     Togliere il parametro serve a una cosa precisa: se il cliente cambia idea
     e la rimuove, un ricaricamento non deve rimettergliela dentro. */

  var DEADLINE = 3000;
  var started = Date.now();

  function stripParam() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('con');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch (e) {
      /* Indirizzo non riscrivibile: non e' un motivo per fallire. */
    }
  }

  function attempt() {
    var match = /[?&]con=(\d+)/.exec(window.location.search);
    if (!match) return true;

    var card = document.querySelector('.dwn-card[data-fragrance="' + match[1] + '"]');
    if (!card) return false;

    /* Fragranza esaurita o gia' nel vassoio: niente da fare, ma il parametro
       ha comunque esaurito il suo compito. */
    if (card.disabled || card.getAttribute('aria-pressed') === 'true') {
      stripParam();
      return true;
    }

    card.click();

    if (card.getAttribute('aria-pressed') === 'true') {
      stripParam();
      return true;
    }

    /* Il clic non ha attecchito: gli ascoltatori della sezione non sono
       ancora legati. Si riprova. */
    return false;
  }

  function loop() {
    if (attempt()) return;
    if (Date.now() - started > DEADLINE) return;
    window.setTimeout(loop, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loop);
  } else {
    loop();
  }
})();
